import PubSub from "underpub-js";

/**
 * OverlayDark
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
var OverlayDark = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  // a variable to hold our timeout for closing the modal
  this.timer = false;

  // our fake selct location button
  this.$selectLocationButton = this.options.$el.find(".select-location");

};

/**
 * Init
 * @return {[type]} [description]
 */
OverlayDark.prototype.init = function(){

  var self = this;

  PubSub.subscribe("showOverlayDarkWithSelectLocationButton", function(options){

    self.$selectLocationButton.css({
      display: "block",
      top: options.offset.top - 10,
      left: options.offset.left
    });

    self.show();

  });

  //
  // We're using various events below to start a timer letting us know when
  // the user has moused over the fake select location button, and the
  // NavSelector ui element
  //

  // when the user mouses over the fake select location button
  this.$selectLocationButton.on("mouseenter", function(){
    self.clearTimer();
  });

  // when the users mouse leaves the fake select location button
  this.$selectLocationButton.on("mouseleave", function(){
    self.startTimer();
  });

  // when the user mouses over the nav selector
  PubSub.subscribe("enterNavSelector", function(){
    self.clearTimer();
  });

  // when the user lealves the nav selector
  PubSub.subscribe("leaveNavSelector", function(){
    self.startTimer();
  });

  // closing the overlay on click
  this.options.$el.on("click", function(e){

    var $target = $(e.target);

    if(self.options.$el.is($target)){
      self.hide();
    }

  });

};

/**
 * Show
 * @return {[type]} [description]
 */
OverlayDark.prototype.show = function(){

  this.options.$el.addClass("is-active");

};

/**
 * Hide
 * @return {[type]} [description]
 */
OverlayDark.prototype.hide = function(){

  var self = this;

  this.options.$el.removeClass("is-active");
  this.$selectLocationButton.removeClass("is-active");

  setTimeout(function(){
    self.$selectLocationButton.css("display", "none");
  }, 400);

};

/**
 * Starting our timer
 * @return {[type]} [description]
 */
OverlayDark.prototype.startTimer = function(){

  var self = this;

  this.timer = setTimeout(function(){
    self.hide();
    PubSub.publish("hideNavSelector");
  }, 350);

}

/**
 * Clearing our timer
 * @return {[type]} [description]
 */
OverlayDark.prototype.clearTimer = function(){

  window.clearTimeout(this.timer);

}

export default  OverlayDark;
